import { type AppTheme } from "@common/declarations";
import { identityPromise } from "@common/lib/misc";
import { identity } from "lodash";
import React from "react";

export type AppContextAi = {
  balance: number;
  updateBalance: (credits: number) => void;
};

export type AppContextProps = {
  ai: AppContextAi;
  context: "admin" | "next";
  theme: AppTheme;

  toggleTheme: () => Promise<void>;
};

const AppContext = React.createContext<AppContextProps>({
  ai: {
    balance: 0,
    updateBalance: identity
  },
  context: "admin",
  theme: "Day",
  toggleTheme: identityPromise
});
export default AppContext;
